import { Badge, Group } from '@mantine/core';
import type { ResolvedFlags } from '@opti-sea/risq';
import { useTranslation } from 'react-i18next';

/** The owner's marks as small labels: types of work, then timing (no flag → "3-m (default)"). */
export function FlagBadges({ flags }: { flags: ResolvedFlags }) {
  const { t } = useTranslation(['dashboard', 'common']);
  return (
    <Group gap={4}>
      {flags.workTypes.map((w) => (
        <Badge key={w} variant="light" color="gray" tt="none">
          {t(`common:workTypes.${w}.name`)}
        </Badge>
      ))}
      {flags.timingIsDefault ? (
        <Badge variant="outline" color="gray" tt="none">
          {t('questions.timingDefault')}
        </Badge>
      ) : (
        flags.prepTiming.map((p) => (
          <Badge key={p} variant="outline" tt="none">
            {t(`common:timings.${p}.short`)}
          </Badge>
        ))
      )}
    </Group>
  );
}
